var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralMenuIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3794_7572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.32808 7.03054H1.96847C0.883034 7.03054 0 6.1475 0 5.06207V1.97046C0 0.883034 0.883034 0 1.96847 0H6.32609C7.41153 0 8.29457 0.883034 8.29457 1.96847V5.06008C8.29457 6.14552 7.41153 7.02855 6.32609 7.02855L6.32808 7.03054ZM1.96847 1.4069C1.65891 1.4069 1.40492 1.65891 1.40492 1.97046V5.06207C1.40492 5.37162 1.65693 5.62562 1.96847 5.62562H6.32609C6.63565 5.62562 6.88965 5.37361 6.88965 5.06207V1.97046C6.88965 1.6609 6.63764 1.4069 6.32609 1.4069H1.96847Z",
    fill: "#2060EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0295 10.9695H11.531C10.4455 10.9695 9.5625 10.0864 9.5625 9.00099V1.96847C9.5625 0.883034 10.4455 0 11.531 0H16.0295C17.1149 0 17.998 0.883034 17.998 1.96847V8.99901C17.998 10.0844 17.1149 10.9675 16.0295 10.9675V10.9695ZM11.531 1.4069C11.2214 1.4069 10.9674 1.65891 10.9674 1.97046V9.00099C10.9674 9.31055 11.2194 9.56455 11.531 9.56455H16.0295C16.339 9.56455 16.593 9.31253 16.593 9.00099V1.96847C16.593 1.65891 16.341 1.40492 16.0295 1.40492H11.531V1.4069Z",
    fill: "#2060EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0295 17.9996H11.531C10.4455 17.9996 9.5625 17.1166 9.5625 16.0311V14.3444C9.5625 13.259 10.4455 12.376 11.531 12.376H16.0295C17.1149 12.376 17.998 13.259 17.998 14.3444V16.0311C17.998 17.1166 17.1149 17.9996 16.0295 17.9996ZM11.531 13.7809C11.2214 13.7809 10.9674 14.0329 10.9674 14.3444V16.0311C10.9674 16.3407 11.2194 16.5947 11.531 16.5947H16.0295C16.339 16.5947 16.593 16.3427 16.593 16.0311V14.3444C16.593 14.0349 16.341 13.7809 16.0295 13.7809H11.531Z",
    fill: "#2060EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.32808 18.0003H1.96847C0.883034 18.0003 0 17.1173 0 16.0318V10.2673C0 9.18186 0.883034 8.29883 1.96847 8.29883H6.32609C7.41153 8.29883 8.29457 9.18186 8.29457 10.2673V16.0318C8.29457 17.1173 7.41153 18.0003 6.32609 18.0003H6.32808ZM1.96847 9.70375C1.65891 9.70375 1.40492 9.95576 1.40492 10.2673V16.0318C1.40492 16.3414 1.65693 16.5954 1.96847 16.5954H6.32609C6.63565 16.5954 6.88965 16.3434 6.88965 16.0318V10.2673C6.88965 9.95774 6.63764 9.70375 6.32609 9.70375H1.96847Z",
    fill: "#2060EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3794_7572"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralMenuIcon);
export default __webpack_public_path__ + "static/media/generalMenuIcon.8f0aca4d1a3cb738f14a30a6e9742a37.svg";
export { ForwardRef as ReactComponent };